import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  perPage: 5,
  pageOptions: [3, 5, 10],
  totalRows: 1,
  sortOptions: [],
  fields: [
    { key: 'name', label: 'Name', sortable: true },
    { key: 'icon', label: 'Icon'},
    { key: 'description', label: 'Description'},
    { key: 'created_at', label: 'Created At'},
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action'},
  ],
  items: []
})

// getters
const getters = {}

// actions
const actions = {
  getAll ({ commit }) {
    let param = {status: 'master/banks/status/AC'}
    useIPA.get(param).then(response => {
      const bank = {
        rows : response.data.data
      }
      commit('setData', {...bank})
    })
  },
  getById ({ commit }, id) {
		return new Promise((resolve, reject) => {
      let param = {status: 'master/bank/' + id}
      useIPA.get(param).then(response => {
          resolve(response.data.data)
      })
    })
  },
  formPostPut ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const rawData = new FormData()
      rawData.set('name', formData.text_1)
      rawData.set('desc', formData.text_2)
      if (formData.setImage === 'upload') {
        rawData.append('icon', formData.icon)
			} else {
        rawData.set('icon', formData.icon)
			}
      const param = { rawData: rawData, url: 'dashboard/master/bank', id: formData.id}
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'bank' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  remove ({ commit }, id) {
		return new Promise((resolve, reject) => {
      const param = { url: 'dashboard/master/bank', id: id }
      useIPA.delete(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	}
}

// mutations
const mutations = {
  setData (state, bank) {
    state.items = bank.rows
    state.totalRows = bank.rows.length
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
